import React, { useState } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Header from "./Header";
import SidebarMenu from "./SidebarMenu";
import Footer from "./Footer";

const DRAWER_WIDTH = 240;

const RootLayout = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleDrawerClose = () => {
        setMobileOpen(false);
    };

    return (
        <>
        <ScrollRestoration />
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            {/* Header */}
            <Header onMenuClick={handleDrawerToggle} showMenuButton={isMobile} />

            <Box sx={{ display: 'flex', flex: 1 }}>
                {/* Sidebar - Mobile Drawer */}
                {isMobile ? (
                    <Drawer
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerClose}
                        ModalProps={{ keepMounted: true }}
                        sx={{
                            '& .MuiDrawer-paper': {
                                boxSizing: 'border-box',
                                width: DRAWER_WIDTH,
                                backgroundColor: '#f7faff',
                            },
                        }}
                    >
                        <Box sx={{ mt: 2 }}>
                            <SidebarMenu onItemClick={handleDrawerClose} />
                        </Box>
                    </Drawer>
                ) : (
                    /* Sidebar - Desktop Permanent */
                    <Box
                        component="nav"
                        sx={{
                            width: DRAWER_WIDTH,
                            flexShrink: 0,
                            backgroundColor: '#f7faff',
                            minHeight: 'calc(100vh - 64px)',
                        }}
                    >
                        <SidebarMenu />
                    </Box>
                )}

                {/* Main content */}
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: { xs: 1, sm: 2, md: 3 },
                        width: { xs: '100%', md: `calc(100% - ${DRAWER_WIDTH}px)` },
                        minHeight: 'calc(100vh - 64px)',
                    }}
                >
                    <Outlet />
                </Box>
            </Box>

            {/* Footer */}
            {/* <Footer /> */}
        </Box>
        </>
    );
}

export default RootLayout;